import ProjectHeroTravelSite from "../../../components/ProjectHero/TravelSite/ProjectHeroTravelSite";
import ProjectDetailsTravelSite from "../../../components/ProjectDetails/TravelSite/ProjectDetailsTravelSite";


function ProjectPageTravelSite() {
    return (
        <>
            <ProjectHeroTravelSite />
            <ProjectDetailsTravelSite />
        </>
    )
}

export default ProjectPageTravelSite;